import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/shared/service/cartService/cart.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from './../../../../shared/service/storage/localstorage.service';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrl: './reservation.component.scss'
})

export class ReservationComponent {
  totalItems = 0;
  filteredCooperatives: any[] = [];  // Liste des coopératives filtrées
  searchQuery: string = '';  // Valeur de recherche de l'utilisateur
  breadCrumbItems: Array<{}>;
  showMachine: boolean = false;
  cart: any[] = [];
  cartItems: any[] = [];
  itemsDetails: any[] = [];
  cooperativeItems: any[] = [];
  dateDebut: any;
  dateFin: any;
  responsiveOptions = [
    {
      breakpoint: '1024px',
      numVisible: 3,
      numScroll: 1
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  machineItems: any = [];
  totalQuantity: number = 0; // Quantité totale
  @ViewChild(NgbPopover) popover: NgbPopover;
  cartMessage:any
  user:any;
  private cartMessageSubscription: Subscription;

  constructor(
    private router: Router,
    private paramService: ParameterService,
    private cartService: CartService,
     private ngxservice: NgxUiLoaderService,
    private messageService: MessageService,
    private localStorageService:LocalStorageService

  ) {
    this.getMachineBylocation();
    this.cartMessageSubscription=this.cartService.cartMessage$.subscribe(message => {
      this.cartMessage = message;
     this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.cartMessage });
        this.totalItems = this.cartService.getTotalItems(); // Mise à jour du total

    });
  }
  ngOnDestroy(): void {
    if (this.cartMessageSubscription) {
      this.cartMessageSubscription.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.user = this.localStorageService.getUsers();
    console.log("this.user",this.user);

    this.getAgriculteur();
    this.breadCrumbItems = [{ label: 'Ecommerce' }, { label: 'Product', active: true }];
    this.totalItems = this.cartService.getTotalItems();
    this.itemsDetails = this.cartService.getCartItems();
    console.log("this.itemsDetails", this.itemsDetails);

  }




  removeItemFromCart(itemId: number): void {
    this.cartService.removeFromCart(itemId);
    this.totalItems = this.cartService.getTotalItems();
  }

  increaseQuantity(item: any): void {
    this.cartService.increaseQuantity(item);
    this.totalItems = this.cartService.getTotalItems();
    this.calculateTotal();
  }

  decreaseQuantity(item: any): void {
    this.cartService.decreaseQuantity(item);
    this.totalItems = this.cartService.getTotalItems();
    this.calculateTotal();

  }


  updateSelectedAccessories(item: any): void {
    const accessoire_selectionne = item.accessoires_machine.filter(accessoire => accessoire.selected);
    item.accessoire_selectionne = accessoire_selectionne || [];
  }

  getMachineBylocation() {
    this.paramService.getMachine().subscribe(
      (response: any) => {
        this.machineItems = response.data;
        console.log("this.machineItems", this.machineItems);

      },
      (error: any) => {
        console.log("une erreur est survenu", error);

      }

    )
  }


  getAgriculteur() {
    this.paramService.getAgriculteur(this.user?.data?.cooperative?.reference).subscribe(
      (response: any) => {
        this.cooperativeItems = response.data;
        console.log("la reponse du webservice", this.cooperativeItems);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }

  filterCooperatives(): void {
    if (this.searchQuery.trim() === '') {
      this.filteredCooperatives = this.cooperativeItems;
    } else {
      this.filteredCooperatives = this.cooperativeItems.filter(cooperative =>
        cooperative.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  }

  // Réinitialiser la recherche
  clearSearch(): void {
    this.searchQuery = '';
    this.filteredCooperatives = []
  }
  cooperative: any;
  // Fonction pour sélectionner un utilisateur/cooperative
  selectCooperative(cooperative: any): void {
    console.log('Coopérative sélectionnée:', cooperative);
    this.cooperative = cooperative;
    this.filteredCooperatives = []
  }
  closePopover() {
    this.popover.close();
  }
  clearSelectedCooperative(): void {
    this.cooperative = null;
  }


  calculateTotal(): number {
    let total = 0;

    this.itemsDetails.forEach(item => {
      // Calcul du montant pour chaque item basé sur sa quantité
      total += item.montant * item.quantity;

      // Ajouter le montant des accessoires sélectionnés (si applicable)
      // if (item.selectedAccessories?.length) {
      //   item.selectedAccessories.forEach(accessoire => {
      //     total += accessoire.accessoire.montant; // Supposons que chaque accessoire a un montant
      //   });
      // }
    });

    return total;
  }
payerDemande(){
  this.router.navigate(['/ikena/paiement-demande']);
}

  saveMachineLocation() {
    if (!this.cooperative) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: "Veuiller ajouter une cooperative" });
      return;
    }
    if (!this.dateDebut) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: "Veuiller ajouter une date de début" });
      return;
    }
    if (!this.dateFin) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: "Veuiller ajouter une date de fin" });
      return;
    }
    if (this.dateDebut > this.dateFin) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: "La date de debut ne peut pas être ultérieure à la date de fin" });
      return;
    }
    const resquestData = {
      panier: this.itemsDetails,
      membre: this.cooperative,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      montant_total: this.calculateTotal(),
      user_id: this.user.data.reference
    };
    console.log("resquestData", resquestData);
    this.ngxservice.start();

    this.paramService.saveMachineLocation(resquestData).subscribe(
      (response: any) => {
        console.log("la reponse du webservice", response);
        localStorage.removeItem('cart');
        this.cartService.clearCart();
        this.router.navigate(['/ikena/locations-machines']);
        this.ngxservice.stop();
      },
      (error: any) => {
        console.log("une erreur est survenue");
        this.ngxservice.stop();
      }
    );
  }


  visible: boolean = false;

  showDialog() {
    this.visible = true;
  }
  addItemToCart(item: any): void {
    const accessoire_selectionne = item.accessoires_machine.filter(accessoire => accessoire.selected);

    const itemWithAccessories = {
      ...item,
      accessoire_selectionne: accessoire_selectionne || [], // Les accessoires sélectionnés
    };

    // Ajout de l'item dans le panier
    this.cartService.addToCart(itemWithAccessories);
    this.itemsDetails = this.cartService.getCartItems();

  }
}
